<template>
  <div class="personal-center">
    <div class="logout-modal" @touchmove.prevent v-if="modalStatus">
      <ul class="action-sheet" :class="{'close':sheetStatus}">
        <li>注销账户？</li>
        <li @click="goArticle(null,'注销用户')">注销账户</li>
        <li @click="cancelSheet">取消</li>
      </ul>
    </div>

    <mt-header fixed title="我的" style="background:#ffffff;color:#262626;">
      <mt-button slot=right @click="openSheet">
        <img class="logout-icon" src="../assets/images/mine_logout@3x.png" alt="">
      </mt-button>
    </mt-header>

    <div class="scroll-wrapper">
      <div class="scroll-content">
        <div class="userinfo">
          <img class="headUrl" src="../assets/images/mine_portrait@3x.png">
          <div class="login-btn" v-if="!loginStatus" @click="goLogin">
            立即登录
          </div>
          <p v-show="loginStatus"><span v-if="nickname!='null'">{{nickname}}</span><span v-if="nickname=='null' && login_phone!='null'">{{login_phone | phoneFormat}}</span></p>
        </div>

        <ul class="app-info" :class="{'logined':loginStatus}">
          <li @click="goOrderList"><img class="orderIcon" src="../assets/images/mine_order@3x.png"><span>订单信息</span></li>
          <li @click="updateMobile"><img class="phoneIcon" src="../assets/images/mine_phone@3x.png"><span>手机绑定</span><span class="phone" v-if="loginStatus"><span v-if="bind_phone!='null'">{{bind_phone | phoneFormat}}</span><span v-if="bind_phone =='null'">未绑定</span></span></li>
          <li @click="goCoupon"><img class="couponIcon" src="../assets/images/mine_coupon@3x.png"><span>优惠券</span></li>
          <li @click="goMessage"><img class="msgIcon" src="../assets/images/mine_message@3x.png"><span>消息中心</span></li>
        </ul>
        
        <ul class="menu">
          <li @click="goSuggestion"><img class="icon" src="../assets/images/mine_feedback@3x.png"><div>建议反馈<img class="more" src="../assets/images/global_more_arrow@3x.png"></div></li>
          <li @click="goArticle(null,'果师兄用户协议')"><img class="icon" src="../assets/images/mine_agreement@3x.png"><div>用户协议<img class="more" src="../assets/images/global_more_arrow@3x.png"></div></li>
          <li @click="goArticle(null,'隐私政策')"><img class="icon" src="../assets/images/mine_privacy@3x.png"><div>隐私政策<img class="more" src="../assets/images/global_more_arrow@3x.png"></div></li>
        </ul>

        <div class="logout" v-if="loginStatus">
          <div class="btn" @click="logout">退出登录</div>
        </div>
      </div>
    </div>
    

    <Footer_></Footer_>
  </div>

</template>

<script>
import Footer_ from './Footer.vue';
import ServiceSteps from './modules/ServiceSteps';
import CopyrightFooter from './modules/CopyrightFooter'
import moment from 'moment'

export default {
  metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
  },
  data(){
    return{
      loginStatus: false,
      login_phone: '',
      bind_phone: '',
      nickname:'',
      modalStatus: false,
      sheetStatus: true,
      app_id: window.config.appid,
      logout_url: window.config.API_URL2+'/v1/logout/deactivate?app_id='+window.config.appid,
      user_url: window.config.API_URL1+'/apph5/page/license?app_id='+window.config.appid,
      yinsi_url: window.config.API_URL1+'/apph5/page/privacy?app_id='+window.config.appid
    }
  },
  mounted(){
        
  },
  created(){
    let access_token = localStorage.access_token
    let expire_time = localStorage.expire_time
    let now = new moment().valueOf()
    if(access_token && expire_time > now){
      this.loginStatus = true
    }else {
      this.loginStatus = false
    }
    this.login_phone = localStorage.login_phone
    this.bind_phone = localStorage.bind_phone
    let bind_phone = this.$route.query.phone
    if(bind_phone){
      this.bind_phone = bind_phone
    }
    this.nickname = localStorage.nickname
  },
  methods:{
    cancelSheet(){
      let vm = this
      vm.sheetStatus = true
      setTimeout(function(){
        vm.modalStatus = false
      },300)
    },
    openSheet(){
      let vm = this
      vm.modalStatus = true
      setTimeout(function(){
        vm.sheetStatus = false
      },300)
    },
    updateMobile(){
      let access_token = localStorage.access_token
      let expire_time = localStorage.expire_time
      let now = new Date().getTime()
      if(access_token && expire_time > now) {
        if(this.bind_phone!='null'){
          //更换手机号码
          this.$router.push({name:'changeMobile'})
        }else {
          //初次绑定手机号
          this.$router.push({name: 'firstBindMobile'})
        }
      }else {
        this.$toastlj("请登录后再进行手机绑定")
      }
      
    },
    logout(){
      let access_token = localStorage.access_token
      let info = {
        access_token: access_token
      }
      this.$store.dispatch('logout',info).then((res)=>{
        this.loginStatus = false
        localStorage.removeItem('access_token')
        localStorage.removeItem('expire_time')
      })
    },
    goLogin(){
      this.$router.push({name:"login",query:{path: 'my',entryButton: '立即登录'}})
    },
    goMessage(){
      if(this.validToken('message','查看消息中心')){
        this.$router.push({name:"message"})
      }
    },
    goCoupon(){
      if(this.validToken('coupon','查看优惠券列表')){
        this.$router.push({name:"coupon"})
      }
    },
    goArticle(url,title){
      this.$router.push({name:"article",query:{url:url,title:title}})
    },
    goSuggestion(){
      this.$router.push({name:"suggestion"})
    },
    goOrderList(){
      if(this.validToken('orderList','查看订单列表')){
        this.$router.push({name:'orderList',query:{path:'my'}})
      }
    },
    goQuestionnaire(gid_){
      this.$router.push({name:"questionnaire",params:{gid:gid_}})
    }
  },
  components:{
    Footer_,
    ServiceSteps,
    CopyrightFooter
  },
  filters: {
    phoneFormat(value){
      let startLen = 3
      let endLen = 4
      if (!value) return ''
      let str = value.toString()
      let len = str.length - startLen - endLen
      let star = ''
      for (var i = 0; i < len; i++) {
      star += "*"
      }
      return str.substring(0, startLen) + star + str.substring(str.length - endLen);

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/My.vue